module.exports = __webpack_public_path__ + "static/images/mercedes-4matic.0b4e4638f685058d20f276ba399407cb.jpg";